
























import capitalize from 'lodash/capitalize';
import Vue, { PropOptions } from 'vue';
import IconBtn from '~/components/builders/IconBtn.vue';
import { Invoice } from '~/services/BillingService';
import { format } from '~/utils/date-fns';
import { InvoiceItem } from '../types';
import Table, { TableHeader } from './Table.vue';

export default Vue.extend({
    name: 'InvoiceTable',
    components: {
        IconBtn,
        Table,
    },
    props: {
        invoices: {
            type: Array,
            default: () => [],
        } as PropOptions<Invoice[]>,
    },
    computed: {
        headers(): TableHeader[] {
            return ['date', 'items', 'status', 'amount', 'download'].map<TableHeader>(col => ({
                label: this.$t(`plansAndBilling.invoices.${col}`).toString(),
                center: col === 'download',
            }));
        },
        invoiceItems(): InvoiceItem[] {
            const amount = (due: number, rem: number, curr: string) => {
                due /= 100;
                rem /= 100;

                const locale = this.$i18n.locale;
                const amtDue = `${due.toLocaleString(locale, {
                    style: 'currency',
                    currency: curr,
                })}`;
                const amtRem = `${rem.toLocaleString(locale, {
                    style: 'currency',
                    currency: curr,
                })}`;

                return amtDue + (!!rem ? ` (${amtRem})` : '');
            };

            return this.invoices.map(invoice => ({
                id: invoice.id,
                date: this.getFormattedDate(invoice.created),
                items: invoice.itemDescriptions.join('<br />'),
                nItems: invoice.itemDescriptions.length,
                status: capitalize(invoice.status),
                amount: amount(invoice.amountDue, invoice.amountRemaining, invoice.currency),
                url: invoice.hostedInvoiceUrl,
            }));
        },
    },
    methods: {
        getFormattedDate(date: Date) {
            if (!(date instanceof Date)) return date;
            return format(date, 'PPP') || '';
        },
        openInvoice(invoice: InvoiceItem) {
            window.open(invoice.url, '_blank');
        },
    },
});
